import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import { AsyncTypeahedSelect, TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import { change, Field, formValueSelector } from "redux-form"
import { getUsersBySearch, updateSurveyResponse } from "store/actions"
import PropTypes from "prop-types"

let Responses = props => {
  const [isResponsesSubmitFailedModalOpen, setIsResponsesSubmitModalOpen] =
    useState(false)

  const handleSubmit = () => {
    if (!props.surveyFeature) {
      setIsResponsesSubmitModalOpen(true)
    } else {
      props.updateSurveyResponse({
        responsesValues: {
          submission_feedback: props.surveyResponse,
          survey_id: props.surveyFeature.id,
          vendor_id: props.vendorId,
        },
        featureRecipientsValues: {
          feature_id: props.surveyFeature.id,
          feature_type: "survey",
          vendor_id: props.vendorId,
          user_ids: props?.selectedAdmins?.map(x => x.value) || [],
        },
      })
    }
  }

  return (
    <>
      <Card>
        <CardBody>
          <Row className="my-3">
            <Col>
              <Field
                name="feedback"
                component={TextField}
                label="Custom response/submission feedback"
                placeholder=""
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name="selectedAdmins"
                component={AsyncTypeahedSelect}
                label="Select admins which will get a copy of each filled out survey"
                placeholder="Search for specific users"
                options={props.usersBySearch.map(user => ({
                  label: `${user.first_name} ${user.last_name} (${user.email})`,
                  value: user.id,
                }))}
                inlineValue={false}
                onInputChange={text =>
                  props.getUsersBySearch({
                    t: text,
                    include_admins: true,
                    only_admins: true,
                  })
                }
                isMulti={true}
              />
            </Col>
          </Row>
          <Row className="mt-4 mb-2">
            <Col className="d-flex justify-content-center">
              <SaveButton type="button" content="Save" onClick={handleSubmit} />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ModalComponent
        title={"Unable to store responses setup"}
        open={isResponsesSubmitFailedModalOpen}
        onClose={() => {
          setIsResponsesSubmitModalOpen(false)
        }}
      >
        <Row>
          <h5>
            Before saving the responses setup, you need to actually create the
            survey.
          </h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              content="Ok"
              onClick={() => {
                setIsResponsesSubmitModalOpen(false)
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
    </>
  )
}

const selector = formValueSelector(FORM_NAMES.SURVEY)

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  surveyResponse: selector(state, "survey_form.responses.feedback"),
  selectedAdmins: selector(state, "survey_form.responses.selectedAdmins"),
  surveyFeature: state.Survey.surveyFeature,
  usersBySearch: state.SiteUsers.usersBySearch,
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.SURVEY, `${field}`, value)),
  updateSurveyResponse: values => dispatch(updateSurveyResponse(values)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
})

Responses.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(Responses)
